import {  AxiosMULEEX, AxiosBookings   } from "../apiConfig";

import { orgId } from "../apiConfig";

export const vehiclesApiFactory = {
  $_getAllVehicles() {
     let url = `/vehicle/getvehicle/${orgId()}`;
    //let url = `/fleets`;
    return AxiosMULEEX.get(url);
  },
  $_createVehicle(payload) {
  // let url = "/vehicle/create-vehicle";
    let url = "/fleets";
    // payload.orgId = orgId();
    return AxiosBookings.post(url, payload);
  },
  // $_getAllTerminals() {
  //   let url = `/route/get-all-terminal/${orgId()}`;
  //   return AxiosMULEEX.get(url);
  // },
  
  $_deleteVehicle(vehicleId) {
    let url = `/vehicle/delete/${vehicleId}`;
    // let requestObject = {
    //   vehicleId,
    // };
    return AxiosMULEEX.delete(url);
  },
  $_getSingleVehicle(vehicleId) {
    let url = `/vehicle/get-vehicle-byid/${vehicleId}`;
    return AxiosMULEEX.get(url);
  },
  $_updateVehicle(payload) {
    let url = "/vehicle/updatevehicle";
    payload.vehicleId = payload.id;
    return AxiosMULEEX.patch(url, payload);
  },
};
